import i18nPlugin from '@/plugins/i18n';
import { BaseNotification } from '@notify/models/notification/types/base';

export class Custom extends BaseNotification {
  constructor(data) {
    super(data);
    this.i18n = data.i18n || null;
  }

  getText() {
    const locale = i18nPlugin.locale;
    try {
      return this.i18n[locale].body;
    } catch (e) {
      return `i18n.custom.${locale}`;
    }
  }

  getTheme() {
    return this.theme;
  }
}
